import { propsFactory } from '@components/utils';

import type { PropType } from 'vue';

export const makeTagProps = propsFactory(
  {
    /**
     * Пользовательский элемент для отображения
     */
    tag: {
      type: String as PropType<string>,
      default: 'div',
      description: 'Пользовательский элемент для отображения'
    }
  },
  'tag'
);
